import { useState } from "react";

const ChatApp = () => {
    const [messages, setMessage] = useState(String);


    return <>
        <h1>Chat</h1>
        <p>{messages}</p>

    </>;
};

export default ChatApp;